// extracted by mini-css-extract-plugin
export var layoutContainer = "_al-0";
export var layoutContainerNoRounding = "_al-6";
export var layoutContainerOpen = "_al-5";
export var layoutContainerResizing = "_al-1";
export var mainContent = "_al-2";
export var resizeDivider = "_al-3";
export var slidePanel = "_al-4";